<h2 mat-dialog-title>Filtros de Processo</h2>
<div mat-dialog-content>
  <form [formGroup]="filterForm">
    <!-- Primeira linha de filtros -->
    <div class="filter-row">
      <mat-form-field appearance="outline">
        <mat-label>Número do Processo</mat-label>
        <input matInput formControlName="numeroProcesso" placeholder="Digite o número do processo" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nome da Empresa</mat-label>
        <input matInput formControlName="empresa" placeholder="Digite o nome da empresa" />
      </mat-form-field>
    </div>

    <!-- Segunda linha de filtros -->
    <div class="filter-row">
      <mat-form-field appearance="outline">
        <mat-label>Modalidade</mat-label>
        <input matInput formControlName="modalidade" placeholder="Digite a modalidade" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Fase</mat-label>
        <input matInput formControlName="fase" placeholder="Digite a fase" />
      </mat-form-field>
    </div>

    <!-- Terceira linha de filtros -->
    <div class="filter-row">
      <mat-form-field appearance="outline">
        <mat-label>CPF/CNPJ</mat-label>
        <input matInput formControlName="cpfCnpj" placeholder="Digite o CPF ou CNPJ" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="situacaoRequerimento">
          <mat-option *ngFor="let situacao of ['Aguardando', 'Em análise', 'Finalizado', 'Cancelado']" [value]="situacao">
            {{ situacao }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" type="button" (click)="applyFilters()">
    Aplicar Filtros
  </button>
  <button mat-raised-button color="warn" type="button" (click)="clearFilters()">
    Limpar Filtros
  </button>
</div>